import React, { useEffect, useState } from "react";
import { getFetch, postFetch } from "../../../../../../fetch/fetch";
import { DataGridPremium, GridRowModel } from "@mui/x-data-grid-premium";
import { Button, IconButton, Modal, ModalDialog } from "@mui/joy";
import { Delete } from "@mui/icons-material";
import { dateToDateString } from "../../../etc/etcfunctions";

interface MemoProps {
    user: any;
    date: Date;
    open: boolean;
    onClose: () => void;
}

const MemoModal: React.FC<MemoProps> = (props) => {

    const [rows, setRows] = useState<any[]>([]);
    const [columns, setColumns] = useState<any[]>([
        { field: "description", headerName: "메모 내용", width: 400, editable: true },
        { field: "author", headerName: "작성자", width: 150 },
        { field: "createdAt", headerName: "작성일", width: 200 },
        {
            field: "delete", headerName: "삭제", width: 100, renderCell: (params: any) => {

                const id = params.row.id;

                const deleteMemo = async () => {
                    try {
                        if (!id) {
                            return;
                        }

                        if (!window.confirm("정말로 메모를 삭제하시겠습니까?")) {
                            return;
                        }

                        setLoading(true);

                        const result: any = await postFetch("/dashboard/salary/deletememo", {
                            memoId: id,
                        });

                        setLoading(false);

                        if (result.message === "success") {
                            setUpdate(Math.random());
                        }

                    } catch (e) {
                        console.log(e);
                    }
                };

                return (
                    <div>
                        <IconButton
                            onClick={deleteMemo}
                        >
                            <Delete />
                        </IconButton>
                    </div>
                )

            }
        }
    ]);
    const [update, setUpdate] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        if (props.open) {
            fetchMemos();
        }

    }, [props.open, update]);

    const fetchMemos = async () => {

        try {
            setLoading(true);

            const result: any = await getFetch("/dashboard/salary/getmemos?userId=" + props.user.id + "&targetMonth=" + (props.date.getMonth()));

            setLoading(false);

            const rowsData: any = [];

            if (result.message === "success") {
                result.data.forEach((item: any) => {
                    const newRow: any = {};

                    newRow.id = item.id;
                    newRow.description = item.description;
                    newRow.author = item.authorName;
                    newRow.createdAt = dateToDateString(new Date(item.createdAt));

                    rowsData.push(newRow);
                }
                );

                setRows(rowsData);
            }
        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    }

    const addMemo = async () => {

        try {

            if (!props.user || !props.user.id) {
                return;
            }

            if (!props.date) {
                return;
            }

            setLoading(true);

            const result: any = await postFetch("/dashboard/salary/addmemo", {
                userId: props.user.id,
                targetMonth: (props.date.getMonth()),
            });

            setLoading(false);

            if (result.message === "success") {
                setUpdate(Math.random());
            }

        } catch (e) {
            console.log(e);
        }

    }

    const handleEditCommit = React.useCallback(
        async (newRow: GridRowModel, old: any) => {
            var field = "";


            for (const [key, value] of Object.entries(newRow)) {
                if (value !== old[key]) {
                    field = key;
                }
            }

            const id = newRow.id;
            const value = newRow[field];

            if (field !== "description") {
                return old;
            }


            fetch("https://peetsunbae.com/dashboard/salary/updatememo", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({
                    memoId: id,
                    field: field,
                    value: value,
                }),
            }).then((res) => res.json())
                .then((data) => {
                    if (data.message === "success") {
                        console.log("메모 수정 성공");
                    } else {
                        alert("메모 수정에 실패했습니다.");
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alert("메모 수정에 실패했습니다.");
                });


            return newRow;
        }, []
    );

    const handleProcessRowUpdateError = React.useCallback((error: Error) => {

        alert(error.message);
    }, []);


    return (
        <div>
            <Modal
                open={props.open}
                onClose={props.onClose}
                aria-labelledby="modal-modal-title"
            >
                <ModalDialog>
                    <div>
                        <div style={{
                            fontSize: "18px",
                            fontWeight: 600,
                            marginBottom: "15px",
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            <div>
                                {props.date.getMonth() + 1}월 메모 내역
                            </div>
                            <div>
                                <Button
                                    variant="outlined"
                                    onClick={addMemo}
                                >
                                    메모 추가하기
                                </Button>
                            </div>
                        </div>
                        <div style={{
                            width: "100%", height: "400px"
                        }}>
                            <DataGridPremium
                                rows={rows}
                                columns={columns}
                                loading={loading}
                                hideFooter={true}
                                density="compact"
                                processRowUpdate={handleEditCommit}
                                onProcessRowUpdateError={handleProcessRowUpdateError}
                            />
                        </div>
                    </div>
                </ModalDialog>
            </Modal>
        </div>
    );

}

export default MemoModal;